import * as React from 'react';
import { Slot } from 'app/area/codetable/item/types';

export const renderSlot = (sectionSlots: Slot, slot: keyof Slot, props: any) => {
  if (!sectionSlots || !sectionSlots[slot]) {
    return null;
  }

  if (Array.isArray(sectionSlots[slot])) {
    return <>
      {sectionSlots[slot].map((SlotToRender, index) => <SlotToRender key={index} {...props} />)}
    </>;
  }

  const SlotComponent = sectionSlots[slot];

  return <SlotComponent {...props} />;
};
